import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import { CancelButton } from '../styling/Styles';
import AuthContext  from './AppAuthContext';

const BuildAppsExitPopUpCannotSave = (props) => {
  const { openAlert, setOpenAlert, aboutToLogout } = props;
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);

  const handleDontSave = () => {
    if (aboutToLogout === false) {
      navigate('/');
    } else {
      dispatch({
        type: 'LOGOUT'
      });
    }
  };

  const handleCancel = () => {
    setOpenAlert(false);
  };

  return (
      <Dialog
        open={openAlert}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">Can not save the project </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            There is a page with unvalid name
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="space-around">
            <Grid item>
              <CancelButton onClick={handleDontSave}>Do not Save</CancelButton>
            </Grid>

            <Grid item>
              <CancelButton onClick={handleCancel}>Cancel</CancelButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
  );
};

export default BuildAppsExitPopUpCannotSave;
